export const parentCompanyKeys = {
  all: ['parent-companies'] as const,

  list: () => [...parentCompanyKeys.all, 'list'] as const,

  detail: (id: string) => [...parentCompanyKeys.all, 'detail', id] as const,

  linkedCompanies: (id: string) => [...parentCompanyKeys.all, 'linked-companies', id] as const,
}
